import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const DevletGiderReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.departmentName || 'Department Name'}</Text>
            <Text style={sharedStyles.businessDetails}>Staff: {data.staffName}</Text>
            <Text style={sharedStyles.businessDetails}>Staff ID: {data.staffId}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Official Expense Report</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Period: {data.reportMonth}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Official Expenses</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={sharedStyles.tableCell}>Date</Text>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Expense Item</Text>
              <Text style={sharedStyles.tableCell}>Category</Text>
              <Text style={sharedStyles.tableCellRight}>Amount</Text>
            </View>
            {data.expenses && data.expenses.map((expense, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={sharedStyles.tableCell}>{expense.date}</Text>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{expense.expenseItem}</Text>
                <Text style={sharedStyles.tableCell}>{expense.category}</Text>
                <Text style={sharedStyles.tableCellRight}>${expense.amount.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Total Expense:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.totalExpense?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Official Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default DevletGiderReportPDF;
